<template>
    <header class="header d-flex justify-content-between">
        <div>
            <button class="navbar-toggle collapsed" data-bs-toggle="collapse" id="menu-toggle">
                <img src="/static/images/menubar.png" alt="Menu" class="menubar" width="42" height="23">
            </button>
            <a href="javascript:void(0)"><img src="/static/images/new-logo.png" alt="Velocity Vehicle Group" class="logo" width="98" height="45"></a>
        </div>
        <div class="d-flex justify-content-between align-self-center">
            <div id="wrap" class="wrap">
                <i id="search-container" class="fa fa-search"></i>
                <div id="search-wrapper" class="search-wrapper">
                    <form action="" autocomplete="on" v-on:submit.prevent="redirectToGlobalSearch()">
                        <input v-model="searchText" id="search" name="search" type="text" placeholder="Search..." class="header-search">
                        <label for="search_submit" class="fa fa-search search-icon">
                            <input id="search_submit" value="search" type="submit" class="d-none">
                        </label>
                        <i id="close-icon" class="fa fa-times close-icon"></i>
                    </form>
                </div>
            </div>
            <div class="dropdown">
                <button type="button" class="dropdown-toggle" data-bs-toggle="dropdown">
                    <div class="dropdown-user d-flex align-items-center">
                        <div class="username-letter">{{loggedin_user_img}}</div>
                        <div class="dropdown-user-right">
                            <div class="username">{{formatString(loggedin_user)}} {{formatString(loggedin_user_last_name)}}</div>
                            <div class="usermailid">{{email}}</div>
                        </div>
                    </div>
                </button>
                <div class="dropdown-menu">
                    <router-link v-if="user_role == 1" class="dropdown-item"  v-bind:to="{name: 'AddEditMenu'}">Edit Menu</router-link>
                    <router-link v-if="user_role == 1" class="dropdown-item"  v-bind:to="{name: 'UserList'}">User</router-link>
                    <a class="dropdown-item" href="javascript:void(0)" v-on:click.prevent="logout">Logout</a>
                </div>
            </div>
        </div>
    </header>
</template>

<script>

    import Vue from 'vue';
    import EventBus from '.././event-bus';
    var contex;
    import {commonMixins} from '../../mixins/commonMixins';

    export default {
        name: "Header",
        mixins: [commonMixins],
        data: () => ({
                profileColor: "",
                isShowLoggedinfields: false,
                loggedin_user_img: '',
                loggedin_user: '',
                loggedin_user_last_name: '',
                role: "",
                email: "",
                image: "/static/images/default.jpg",
                searchText : "",
            }),
        beforeMount: function () {
            contex = this;
        },
        mounted: function () {
            var self = this;
            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                self.getUserPermissions();
                var profileColor = localStorage.getItem('profileColor');
                if (profileColor && profileColor != null) {
                    self.profileColor = profileColor;
                } else {
                    self.profileColor = self.gerRandomColor();
                    localStorage.setItem("profileColor", self.profileColor);
                }
                if (self.profileColor != "") {
                    /*$(".username-letter").css({"background": self.profileColor});*/
                }
                var location = window.location.pathname;
                if (location.indexOf("globalsearch") != -1) {
                    self.redirectToGlobalSearch();
                }
            }
            //self.$store.dispatch('getRole');
        },
        methods: {

            redirectToGlobalSearch : function() {
                var self = this;
                var location = window.location.pathname;
                var n =  location.lastIndexOf('/');
                var result = decodeURI(decodeURI(location.substring(n + 1)));
                if(self.searchText == ""){
                    self.searchText = result;
                }
                if (self.searchText.length > 2) {
                    if (location === "/globalsearch") {
                        self.$router.replace({ name: 'GlobalSearchView', params: {searchText: self.searchText }}).catch(()=>{});
                        // EventBus.$emit("on-globalsearch", self.searchText);
                        // window.location.href = "/globalsearch";
                    } else {
                        self.$router.push({ name: 'GlobalSearchView', params: {searchText: self.searchText }}).catch(()=>{});
                    }
                }
                setTimeout(function(){
                    $('[data-bs-toggle="tooltip"]').tooltip({
                        html: true
                    });
                },900);
            },

            logout: function () {
                //clear all local storage
                let current_build = window.localStorage.getItem("build_version");
                localStorage.clear();
                localStorage.setItem("build_version", current_build);
                // window.location.href = "/";
                //contex.$router.push("/");

                // Auto-logout Current Project From SSO
                window.location.href = process.env.VUE_APP_SSO_ROOT_URL + "/logout?redirect_url=" + process.env.VUE_APP_FRONT_ROOT_URL + '&slug=' + process.env.VUE_APP_PROJECT_SLUG;
            },

            formatString: function (data) {
                var self = this;
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp.toUpperCase();
            },

        },

    };

    EventBus.$on('logged-in', function (isLogin, name, lastName, email,username) {
        contex.isShowLoggedinfields = isLogin;
        contex.loggedin_user = name.trim();
        contex.loggedin_user_last_name = lastName.trim();
        contex.loggedin_user_img = (contex.loggedin_user.charAt(0) + contex.loggedin_user_last_name.charAt(0)).toUpperCase();
        contex.email = email;
        if (contex.loggedin_user_img == "") {
            contex.loggedin_user_img = (contex.email.charAt(0) + contex.email.charAt(1)).toUpperCase();
        }
        //contex.role = role;
        //contex.image = "/static/images/default.jpg";

        /* if (file_path != null){
         contex.image = file_path;
         }else{
         contex.image = "/static/images/default.jpg";
         } */

    });

    EventBus.$on('on-globalsearch', function () {
        contex.searchText = "";
    })

    $(document).ready(function(){
        $("#close-icon").click(function(){
            $("#search-wrapper").hide();
        })
        $("#search-container").click(function(){
            $("#search-wrapper").show();
        });
    });
</script>